export default __webpack_public_path__ + "static/media/chapter2.f9f10029.jpg";